/* The Finance area's views: the eight Treasury views, then Revenue and the
   finance list. Each has its own URL, /finance?view=<id>. */

export const TREASURY_VIEWS = [
  { id: 'summary', label: 'Summary' },
  { id: 'months', label: 'Month by month' },
  { id: 'spending', label: 'Spending' },
  { id: 'cuts', label: 'Cuts' },
  { id: 'scenarios', label: 'Scenarios' },
  { id: 'bank', label: 'Bank and cards' },
  { id: 'renewals', label: 'One-offs and renewals' },
  { id: 'assumptions', label: 'Assumptions' },
] as const;

export const OTHER_VIEWS = [
  { id: 'revenue', label: 'Revenue' },
  { id: 'access', label: 'Finance access' },
] as const;

export type TreasuryView = (typeof TREASURY_VIEWS)[number]['id'];
export type FinanceView = TreasuryView | (typeof OTHER_VIEWS)[number]['id'];

export const DEFAULT_FINANCE_VIEW: FinanceView = 'summary';

const TREASURY_IDS = new Set<string>(TREASURY_VIEWS.map((v) => v.id));
const VIEW_IDS = new Set<string>([
  ...TREASURY_IDS,
  ...OTHER_VIEWS.map((v) => v.id),
]);

export const isFinanceView = (value: unknown): value is FinanceView =>
  typeof value === 'string' && VIEW_IDS.has(value);

export const isTreasuryView = (value: FinanceView): value is TreasuryView =>
  TREASURY_IDS.has(value);

/** The Management tabs Finance used to be, and the view each opens now. */
export const LEGACY_MANAGEMENT_TABS: Record<string, FinanceView> = {
  treasury: 'summary',
  revenue: 'revenue',
};
